import { map } from "lodash";
import { useAnalyticsModalContext } from "PFApp/analytics/parts/top_actions_panel/analytics_modal_context_provider";
import { getTemplateReportType } from "PFApp/analytics/parts/top_actions_panel/export_wizard_content/helpers";
import { useRequiredFields } from "PFApp/analytics/parts/top_actions_panel/export_wizard_content/use_required_fields";
import { ExportField, ExportFields, ExportType } from "PFApp/analytics/types/export_analytics";
import Toggle from "PFComponents/toggle/toggle";
import React, { JSX } from "react";

import css from "./field_category.module.scss";

interface FieldCategoryItemsProps {
  categoryKey: string;
  fields: ExportFields;
  onFieldToggleProvider: (field: ExportField) => (checked: boolean) => void;
}

const buildFieldId = (categoryKey: string, fieldKey: string) => `${categoryKey}-${fieldKey}`;

export const FieldCategoryItems = ({
  categoryKey,
  fields,
  onFieldToggleProvider
}: FieldCategoryItemsProps): JSX.Element => {
  const {
    state: {
      data: { exportType, selectedFields, selectedTemplate }
    },
    updateData
  } = useAnalyticsModalContext();
  const { requiredKeys } = useRequiredFields();

  return (
    <ul className={css.itemsRoot}>
      {map(fields, (item, fieldKey) => {
        const fieldId = buildFieldId(categoryKey, fieldKey);
        const checked = selectedFields.some(({ id }) => id === fieldId);
        const handleToggleChange = (checked: boolean) => {
          if (exportType === ExportType.Template) {
            updateData({
              exportType: ExportType.Custom,
              ...(selectedTemplate ? { reportType: getTemplateReportType(selectedTemplate) } : {})
            });
          }
          onFieldToggleProvider({ ...item, id: fieldId })(checked);
        };

        return (
          <li key={fieldKey}>
            <Toggle
              reversed
              description={item.title}
              checked={checked}
              onChange={handleToggleChange}
              disabled={requiredKeys.includes(fieldKey)}
              required={requiredKeys.includes(fieldKey)}
            />
          </li>
        );
      })}
    </ul>
  );
};
